import React from "react";
import FreightKitLanding from "../marketing/FreightKitLanding";

export function Home() {
  return (
    <div>
      <FreightKitLanding />
    </div>
  );
}

export default Home;
